import { render } from "./PreviewCard.vue?vue&type=template&id=d85292f8&scoped=true"
import script from "./PreviewCard.vue?vue&type=script&lang=js"
export * from "./PreviewCard.vue?vue&type=script&lang=js"

import "./PreviewCard.vue?vue&type=style&index=0&id=d85292f8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d85292f8"

export default script